import React from "react";
import { cn } from "@/react/shadcn/utils";

function Skeleton({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"div"> & { className?: string }) {
  return (
    <div
      className={cn(
        "web3kit-animate-pulse web3kit-rounded-md web3kit-bg-foreground/10",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
